export const TYPE_SITE_COMERCIALIZADOR = '10';
export const COMM_CHANNEL_DIGITAL = '07';
export const DESTINY_E_REDES = '01';
export const INTERLOCUTOR_CLIENTE = '01';
export const INTERLOCUTOR_COMERCIALIZADOR = '04';
export const ATTENDING_POINT = '50000058';
export const SOLVED_STATUS_CODE = '11';
